import { SendRawMessageActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/SendRawMessageActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
export const CONTENT_TYPES = [
    'application/json',
    'application/vnd.lime.media-link+json',
    'application/vnd.lime.web-link+json',
    'application/vnd.iris.ai.transcribe+json',
    'application/vnd.iris.ai.content-combination+json',
    'application/vnd.iris.ai.blufaq-answer+json',
    'application/vnd.iris.ai.blipvision+json',
    'application/vnd.lime.select+json',
    'application/vnd.lime.document-select+json',
    'application/vnd.lime.collection+json',
    'application/vnd.lime.location+json',
    'application/vnd.lime.input+json',
    'application/vnd.lime.chatstate+json',
    'application/vnd.lime.list+json',
    'application/vnd.lime.container+json',
    'application/vnd.lime.invoice+json',
    'application/vnd.lime.invoice-status+json',
    'application/vnd.lime.payment-receipt+json',
    'application/vnd.lime.sensitive+json',
    'application/vnd.iris.resource+json',
    'application/vnd.lime.redirect+json',
    'application/vnd.iris.schedule+json',
    'application/vnd.iris.desk.attendance-survey-answer+json',
    'text/plain',
];
export class RawContentController extends ActionController {
    static $inject = ['action', 'close', '$onStateChanged', 'ModalService', 'UndoRedoService', 'state', '$rootScope', '$scope'];
    constructor(action, close, $onStateChanged, ModalService, UndoRedoService, state, $rootScope, $scope) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope });
        this.ModalService = ModalService;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.openEditModal = false;
        this.onChangeRawContent = (event) => {
            this.action.settings.rawContent = event.detail?.value;
        };
        this.types = CONTENT_TYPES.map((name) => ({ label: name, value: name }));
        if (!this.types.some(({ value }) => value == this.action.settings.type)) {
            const newType = {
                value: this.action.settings.type,
                label: this.action.settings.type,
            };
            this.types.push(newType);
        }
    }
    create() {
        return new SendRawMessageActionSettings();
    }
    updateType() {
        this.action.settings.type = this.selectedType?.name;
    }
    async selectStatusFilter(value) {
        const selectedValue = value;
        this.action.settings.type = selectedValue || '';
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
    get selectedType() {
        return this.action.settings?.type;
    }
    addNewOption(value) {
        const newType = {
            value,
            label: value,
        };
        this.action.settings.type = value;
        this.types.push(newType);
    }
    toggleEditModal() {
        this.openEditModal = !this.openEditModal;
    }
    saveSource() {
        const input = document.getElementById('raw-content-source');
        if (input) {
            input.focus();
            this.action.settings.rawContent = input.value;
            this.toggleEditModal();
        }
    }
}
RawContentController.$inject = ['action', 'close', '$onStateChanged', 'ModalService', 'UndoRedoService', 'state', '$rootScope', '$scope'];
